import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

type State = "success" | "waiting" | "warning" | "missing" | "inprogress1" | "inprogress2";
export const IconEnvState: FC<{ state: State } & PropsWithClassName> = ({ state, className }) => {
    switch (state) {
        case "success":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_14_772)">
                        <path
                            d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z"
                            fill="#17C165"
                            stroke="rgba(113, 236, 135, 0.3)"
                            strokeWidth="3"
                        />
                        <path d="M8 12.5L11 15L16 9" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_14_772">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "waiting":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_14_785)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                            fill="#64645F"
                        />
                        <path
                            d="M12 18C8.68628 18 6 15.3137 6 12C6 8.6863 8.68628 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18Z"
                            stroke="#64645F"
                            strokeOpacity="0.2"
                            strokeWidth="6"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_14_785">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "warning":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_14_793)">
                        <path
                            d="M12 9.36996V12.3154M12 14.3404V14.3331M10.1211 6.14899L5.4324 13.7308C4.52227 15.2025 5.58084 17.1018 7.31124 17.1018H16.6887C18.4191 17.1018 19.4777 15.2025 18.5675 13.7308L13.8788 6.14898C13.0154 4.75275 10.9846 4.75275 10.1211 6.14899ZM12.1841 14.3404C12.1841 14.4421 12.1017 14.5245 12 14.5245C11.8983 14.5245 11.8159 14.4421 11.8159 14.3404C11.8159 14.2387 11.8983 14.1564 12 14.1564C12.1017 14.1564 12.1841 14.2387 12.1841 14.3404Z"
                            stroke="#E5484D"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_14_793">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "missing":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_14_789)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3 12C3 16.9706 7.02941 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02943 16.9706 3 12 3C7.02941 3 3 7.02943 3 12Z"
                            fill="#64645F"
                            fillOpacity="0.2"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_14_789">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "inprogress1":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_14_777)">
                        <path
                            d="M16 12C16 14.2092 14.2092 16 12 16C9.79086 16 8 14.2092 8 12C8 9.79086 9.79086 8 12 8C14.2092 8 16 9.79086 16 12Z"
                            fill="#FF8A00"
                        />
                        <path
                            d="M16 12C16 14.2092 14.2092 16 12 16C9.79086 16 8 14.2092 8 12C8 9.79086 9.79086 8 12 8C14.2092 8 16 9.79086 16 12Z"
                            stroke="rgba(255, 188, 88, 0.3)"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_14_777">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "inprogress2":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_14_781)">
                        <path
                            d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85787 16.1422 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1422 7.85787 19.5 12 19.5Z"
                            fill="#FF8A00"
                            stroke="rgba(255, 188, 88, 0.3)"
                            strokeWidth="5"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_14_781">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
